$(function () {
    if ($('.sustainability-front-page').length > 0) {
        var scroll_position = 0;
        var direction = 'down';
        var displacement = 0;
        var frame1_item1_position = 0;
        var frame2_item_position = 0;
        var frame1_item1_value = {
            inside: 0,
            outside: 0,
            scale: 1,
        };
        var frame2_value = -100;

        $('.latest-articles').hide();    
        $('.frame-1').css('display', 'flex');
        $('.frame-1 .item-1 .frame-outside').animate({opacity: 0.1}, 1000);
        $('.frame-2').css('display', 'block');
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 500);
        setTimeout(() => {
            $('.loader > div').css({'transform': 'scale(100)', 'opacity': 0.1});
            setTimeout(() => {
                $('.loader').hide();
            }, 200);
        }, 1500);


        $(window).scroll(function (e) {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop < scroll_position) {
                direction = 'up';
            } else {
                direction = 'down'
            }

            displacement = scrollTop - scroll_position;
            scroll_position = scrollTop;

            // console.log(direction, displacement);
            frame1_item1(direction, displacement);
            if(scroll_position <= $('.frame-2').offset().top - $(window).height()){
                frame2_item(direction, -100);
            }else if(scroll_position >= ($('.frame-2').offset().top - $(window).height()) + $('.frame-2').outerHeight(true)){
                frame2_item(direction, 100);
            }else if(scroll_position > $('.frame-2').offset().top - $(window).height() && scroll_position < ($('.frame-2').offset().top - $(window).height()) + $('.frame-2').outerHeight(true)){
                frame2_item(direction, displacement);
            }
        });

        function frame1_item1(direction, displacement) {
            var frame_height = $('.frame-1').outerHeight(true) - $('.frame-1 .item-1').height() - (($(window).height() - $('.frame-1 .item-1').height()) / 2);
            if (frame1_item1_position + displacement < 0) {
                frame1_item1_position = 0;
            }else if (frame1_item1_position + displacement > frame_height) {
                frame1_item1_position = frame_height;
            }else{
                frame1_item1_position += displacement;
            }

            frame1_item1_value.outside = ((frame1_item1_position * 3) / frame_height < 1 ? (frame1_item1_position * 3) / frame_height : 1).toFixed(2);
            if(frame1_item1_value.outside < 0.1){
                frame1_item1_value.outside = 0.1;
            }

            frame1_item1_value.inside = ((frame1_item1_position * 2) / frame_height < 1 ? (frame1_item1_position * 2) / frame_height : 1).toFixed(2);

            if(frame1_item1_value.inside >= 0.6){
                frame1_item1_value.scale = (1 + ((frame1_item1_position / frame_height) * 40)).toFixed(2);
            }else{
                frame1_item1_value.scale = 1;
            }
            
            // console.log(frame1_item1_value);

            $('.frame-1 .item-1').css('transform', 'scale(' + frame1_item1_value.scale + ')');
            $('.frame-1 .item-1 .frame-outside').css('opacity', frame1_item1_value.outside);
            $('.frame-1 .item-1 .frame-inside').css('opacity', frame1_item1_value.inside);
        }
        
        function frame2_item(direction, displacement) {
            var frame_height = $('.frame-2').outerHeight(true);
            if (frame2_item_position + displacement < 0) {
                frame2_item_position = 0;
            }else if (frame2_item_position + displacement > frame_height) {
                frame2_item_position = frame_height;
            }else{
                frame2_item_position += displacement;
            }
            
            
            frame2_value = parseInt((-1 * ((1 - (frame2_item_position / frame_height < 1 ? frame2_item_position / frame_height : 1)) * 100)));
            if(frame2_value < -100){
                frame2_value = -100;
            }else if(frame2_value > 0){
                frame2_value = 0;
            }

            
            $('.frame-2 .left-side').css('top', frame2_value + 'vh');
            $('.frame-2 .right-side').css('bottom', frame2_value + 'vh');
            $('.frame-2 .left-side h3').css('left', (frame2_value / 2) + 'vw');
            $('.frame-2 .right-side h3').css('right', (frame2_value / 2) + 'vw');
            if(frame2_value >= 0){
                $('.frame-2 .left-side, .frame-2 .right-side').css('position', 'absolute');
            }else{
                $('.frame-2 .left-side, .frame-2 .right-side').css('position', 'fixed');
            }
        }

        $('.js-page-open').on('click', function(){
            pageOpen($(this).data('page'));
        });
        function pageOpen(page){
            $('#page-' + page).show();
            $('.latest-articles').show();
            $('html,body').animate({scrollTop: $('#page-' + page).offset().top}, 500);
            setTimeout(() => {
                pageAnimate(page);
                $('.sustainability-front-page').hide();
            }, 600);
    
        }


        /* Megic scroll */
         // init controller
         var controller = new ScrollMagic.Controller();

         function pageAnimate(page){

            // type 2
            $(`#page-${page} .page-section-2`).each(function(){
                var id = $(this).attr('id');
                var scene2 = new ScrollMagic.Scene({
                    triggerElement: `#${id}`,
                    triggerHook: 0.8
                })
                .addTo(controller);
        
                var tween1 = TweenMax.to(`#${id} .text`, 0.3, {left: 0});
                var tween2 = TweenMax.to(`#${id} img`, 0.5, {left: '55%'});
                
                scene2.setTween([tween1, tween2]);
            });
            
            //  type 3
            $(`#page-${page} .page-section-3`).each(function(){
                var id = $(this).attr('id');
                for(var i = 0; i < 20; i++ ){
                    if($(this).find(`.row-${i}`).length > 0){
                        var scene3 = new ScrollMagic.Scene({
                            triggerElement: `#${id} .row-${i}`,
                            triggerHook: 0.8
                        })
                        .addTo(controller);
                        var tween1 = TweenMax.to(`#${id} .row-${i} .left`, 0.8, {left: 0});
                        var tween2 = TweenMax.to(`#${id} .row-${i} .right`, 1, {right: 0});
                        
                        scene3.setTween([tween1, tween2]);
                    }
                }
            });
            
            // type 7
            $(`#page-${page} .page-section-7`).each(function(){
                var id = $(this).attr('id');
                var scene7 = new ScrollMagic.Scene({
                    triggerElement: `#${id}`,
                    triggerHook: 0.7
                })
                .setTween(TweenMax.to(`#${id} .row`, 0.8, {opacity: 1}))
                .addTo(controller);    
            });
            
            
            //  type 6
            $(`#page-${page} .page-section-6`).each(function(){
                var id = $(this).attr('id');
                var scene3 = new ScrollMagic.Scene({
                    triggerElement: `#${id}`,
                    triggerHook: 0.8
                })
                .addTo(controller);
                var tween1 = TweenMax.to(`#${id} .left`, 0.8, {left: 0});
                var tween2 = TweenMax.to(`#${id} img`, 1, {right: 0});
                
                scene3.setTween([tween1, tween2]);
            });

            // type 8
            $(`#page-${page} .page-section-8`).each(function(){
                var id = $(this).attr('id');
                var scene7 = new ScrollMagic.Scene({
                    triggerElement: `#${id} .content`,
                    triggerHook: 0.8
                })
                .setTween(TweenMax.to(`#${id} .content`, 0.8, {opacity: 1}))
                .addTo(controller);    
            });
        }
    }
});